import API from "@services/root/rootApi";
import {
  TroubleshootRequest,
  TroubleshootResponse,
  TroubleshootPayload,
} from "./types";

/**
 * Convert the data in the shape the BE wants them
 */
const toPayload = ({
  error,
  account,
  device,
  ticket,
}: TroubleshootRequest): TroubleshootPayload => {
  const { manufacturer, softwareVersion, model } = device;
  const { id: accountId } = account;

  let ticketPayload =
    ticket === undefined
      ? undefined
      : {
          id: ticket.id,
          issues:
            ticket.issue === undefined
              ? undefined
              : ([ticket.issue.issue, ticket.issue.subTypes]
                  .flat()
                  .filter((x) => x !== undefined) as string[]),
        };
  return {
    error,
    account: { id: accountId },
    device: {
      manufacturer,
      model,
      version: softwareVersion,
    },
    ticket: ticketPayload,
  };
};
export const getTroubleshoot = async (
  req: TroubleshootRequest,
  page: number
): Promise<TroubleshootResponse> => {
  return (
    await API.post(
      `/symphony-api/provisioning/device/troubleshoot/messages?num=${page}`,
      toPayload(req)
    )
  ).data;
};
